/* eslint-disable prefer-destructuring */
import reduxListener from './reduxListener';
import { PAGE_META } from '../pageMeta/actions';

let pageType = null;
// TODO: refactor for SPA
const pageTypeReduxListener = reduxListener(PAGE_META.SET_PAGE_TYPE, (action) => {
	pageType = action.payload;
});

export {
	pageTypeReduxListener
};
